import { createPortal } from "react-dom"

interface UploadedConversationsVisualizerOverlayHoverCardProps {
  bucketLabel: string
  firstSentence: string
  x: number
  y: number
}

export function UploadedConversationsVisualizerOverlayHoverCard({
  bucketLabel,
  firstSentence,
  x,
  y,
}: UploadedConversationsVisualizerOverlayHoverCardProps) {
  return createPortal(
    <div
      className="pointer-events-none fixed z-50 min-w-44 max-w-72 rounded-md border border-coval-border bg-surface-default px-2.5 py-2 shadow-lg"
      data-testid="uploaded-conversations-overlay-hover-card"
      style={{
        left: `${x}px`,
        top: `${y}px`,
        transform: "translate(-50%, calc(-100% - 10px))",
      }}
    >
      <p className="text-[11px] font-medium uppercase tracking-wide text-coval-text-muted">
        {bucketLabel}
      </p>
      <p className="mt-1 text-xs text-coval-text">{firstSentence}</p>
    </div>,
    document.body,
  )
}
